<template>
  <div class="invoice-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else>
      <v-card flat>
        <PrintViewBar v-if="Invoice" :showEmailBtn="showEmailBtn" :id="Invoice.id" type="invoice" />

        <!-- :title="`Invoice # ${this.Invoice.localId}`"
          :postfix="`view?key=${currentBusiness.code}`"
          :name="currentBusiness.name"
          :email="Invoice.Customer.email"
          :obj="Invoice.Customer"
          :text="`${currentBusiness.name} Invoice click here to view`" -->

        <v-container fluid v-if="Invoice">
          <v-card-text class="pb-0">
            <div v-if="!$vuetify.breakpoint.xsOnly">
              <!-- <img
                class="paidImg"
                v-if="Invoice.due === 0"
                width="300"
                src="../../../assets/paidStamp.png"
              /> -->
              <!-- <img class="paidImg" v-if="Invoice.deletedAt" width="300"
                src="../../../../assets/deletedStamp-removebg-preview.png" /> -->
            </div>
            <v-layout row wrap v-if="currentBusiness">
              <v-flex class="text-left text-capitalize">
                <div class="headline font-weight-bold">
                  <div v-if="currentBusiness.DBAName">{{ currentBusiness.DBAName }}</div>
                  <div v-else>{{ currentBusiness.StoreName }}</div>
                </div>
                <div class="font-weight-medium">
                  {{ currentBusiness.Address }} {{ currentBusiness.City }},
                  <span class="text-uppercase">{{ currentBusiness.StateName }}
                  </span>
                  {{ currentBusiness.ZipCode }}
                </div>
                <div class="font-weight-medium">
                  {{ currentBusiness.PhoneNumber }}
                </div>
                <div class="font-weight-medium text-lowercase">
                  {{ currentBusiness.StoreEmail }}
                </div>
                <div class="font-weight-medium text-lowercase">
                  {{ currentBusiness.WebSite }}
                </div>

                <div  class="mt-2 display-3 text-uppercase font-weight-black blue--text">
                  {{ Invoice.Title }}
                </div>
                <div class="font-weight-regular mt-2">
                  <div class="font-weight-medium">BILL TO</div>
                  <div class="font-weight-bold">
                    {{ Invoice.AccountName }}
                  </div>
                  <div v-if="Invoice.PhoneNumber">{{Invoice.PhoneNumber}}</div>
                  <!-- <div>{{ Invoice.Customer.address }}</div>
                  <div v-if="Invoice.Customer.city">
                    {{ Invoice.Customer.city }},<span class="text-uppercase"
                      >{{ Invoice.Customer.state }}
                    </span>
                    {{ Invoice.Customer.zip }}
                  </div> -->
                </div>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink class="text-right">
                <!-- <div v-if="!$vuetify.breakpoint.xsOnly">
                  <img
                    v-if="currentBusiness.imageUrl"
                    height="120"
                    class="logo mb-3"
                    :src="currentBusiness.imageUrl"
                    alt=""
                  />
                </div>
                <div v-if="!$vuetify.breakpoint.xsOnly" class="barcode mt-2">
                  <span v-if="currentBusiness.metadata.barcodeOnInvoice"
                    >*{{ Invoice.localId }}*</span
                  >
                </div> -->
                <div class="font-weight-regular">
                  <v-layout row>
                    <v-flex>
                      <div class="text-right">INVOICE #</div>
                      <div class="text-right">DATE:</div>
                      <div class="text-right">SALES REP:</div>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex shrink>
                      <div class="text-left">{{ Invoice.InvoiceID }}</div>
                      <div class="text-left">
                        {{ Invoice.InvoiceDate | moment("MM/DD/YYYY") }}
                      </div>
                      <div class="text-left">
                        {{ Invoice.EmployeeName }}
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <!-- <v-card-text class="pb-0" v-if="Invoice.Customer.showBalance">
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-flex shrink>
                <div class="headline font-weight-medium text-right blue--text">
                  BALANCE
                </div>
                <div class="display-2 font-weight-light text-right">
                  {{ Invoice.Customer.balance | currency }}
                </div>
                <br />
              </v-flex>
            </v-layout>
          </v-card-text> -->
          <table class="center">
            <!-- <v-divider class="mx-3"></v-divider> -->
            <tbody class="report-container">
              <v-card-text v-if="InvoiceDetails.length">
                <v-data-table dense sort-by="id" :headers="headers" :itemsPerPage="InvoiceDetails.length"
                  hide-default-footer :items="InvoiceDetails">
                  <template v-slot:item="{ item }">
                    <tr>
                      <td class="text-left">
                        <div>{{ item.ProductName }}</div>
                        <div v-if="item.IMEINumber">{{ item.IMEINumber }}</div>
                        <!-- <div v-if="item.PhoneNumber">
                        <v-chip small label>Phone Number: {{ item.PhoneNumber }}</v-chip>
                        </div> -->
                      </td>
                      <td class="text-center">{{ parseInt(item.Quantity) }}</td>
                   
                      <td class="text-right">
                        {{ (item.SellingPrice) | currency }}
                      </td>
                      <td class="text-right">
                        {{ (item.LineTotal) | currency }}
                      </td>

                      
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </tbody>
          </table>
          <v-card-text class="pr-4">
            <v-divider></v-divider>
            <v-row>
              <v-col cols="3">
                <span>{{Invoice.Notes}}</span>
                <!-- <span v-if="showEmailBtn" @click="showCost = !showCost" class="pointer font-weight-medium">
                  {{ totalQty }} ITEM(S) SOLD
                </span>
                <span v-else @click="showCost = !showCost" class="font-weight-medium">
                  {{ totalQty }} ITEM(S) SOLD
                </span> -->

                <!-- <div class="signature">
                  <v-divider></v-divider>
                  <div>Signature</div>
                </div> -->
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="5">
                <v-layout>
                  <v-flex>
                    <div class="font-weight-medium">SUBTOTAL:</div>
                  </v-flex>
                  <v-flex>
                    <div class="font-weight-medium text-right">
                      {{ Invoice.SubTotal | currency }}
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <div class="font-weight-medium">DISCOUNT:</div>
                  </v-flex>
                  <v-flex>
                    <div class="font-weight-medium text-right">
                      {{ Invoice.Discount | currency }}
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout v-for="(payment, index) in Payments" :key="index">
                  <v-flex >
                    <div class="text-right">
                      {{ payment.PaymentTypeName }}
                    </div>
                  </v-flex>
                  <!-- <v-flex>
                    <div class="text-right" v-if="
                      currentBusiness.metadata &&
                      currentBusiness.metadata.hidePaymentDate
                    ">
                      {{ payment.createdAt | moment("LL") }}
                    </div>
                  </v-flex> -->
                  <v-flex xs5>
                    <div class="red--text text-right">
                      -{{ payment.Amount | currency }}
                    </div>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout>
                  <v-flex>
                    <div class="font-weight-medium">TOTAL PAID:</div>
                  </v-flex>
                  <v-flex>
                    <div class="font-weight-medium red--text text-right">
                      -{{ totalPayment | currency }}
                    </div>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout>
                  <v-flex>
                    <div class="font-weight-medium">INVOICE DUE AMOUNT:</div>
                  </v-flex>
                  <v-flex>
                    <div class="font-weight-medium text-right">
                      {{ parseFloat(Invoice.DueAmount) - totalPayment | currency }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-col>
            </v-row>

            <div class="my-5" v-if="currentBusiness &&
              currentBusiness.metadata &&
              currentBusiness.metadata.openInvoiceListOnInvoice
            ">
              <div v-if="OpenInvoices.length">
                <div class="title">Open Invoices</div>
                <OpenInvoiceList v-if="OpenInvoices" class="mt-3" :Invoice="OpenInvoices" />
              </div>
            </div>

            <!-- <div v-if="currentBusiness.policy">
              <div class="font-weight-medium">POLICY</div>
              <v-divider></v-divider>
              <div style="line-height: 12px">
                <small>{{ currentBusiness.policy }}</small>
              </div>
            </div> -->

            <!-- <v-col align="right">
              <img width="100" src="@/assets/images/poweredbylogo.png" />
            </v-col> -->
          </v-card-text>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import PrintViewBar from "@/components/PrintViewBar";
// import OpenInvoiceList from "@/modules/Invoice/components/OpenInvoiceList.vue";
import reportService from '@/pages/Report/service.js'
import { mapGetters, mapActions } from "vuex";
// const hashids = new Hashids();
import locationService from '@/pages/Location/service.js'

export default {
  name: 'invoice-receipt-view',
  props: ['location', 'item'],
  data() {
    return {
      Payments: null,
      currentBusiness: null,
      InvoiceDetails: [],
      totalPayment: 0,
      OpenInvoices: [],
      showCost: false,
      showEmailBtn: false,
      isLoading: true,
      Invoice: null,
      headers: [
        {
          text: "ITEM NAME",
          align: "left",
          value: "productDetail",
          sortable: false,
        },
        {
          text: "QTY",
          align: "center",
          value: "qty",
          sortable: false,
        },
        {
          text: "RATE",
          align: "right",
          value: "rate",
          sortable: false,
        },
        {
          text: "TOTAL",
          align: "right",
          value: "total",
          sortable: false,
        },
      ],
      totalQty: 0,
    };
  },
  // computed: {
  //   ...mapGetters("global", ["currentBusiness"]),
  // },
  created() {
    console.log('i got call')
    this.getSettings()
    this.loadData();
    this.getPaymentByInvoiceId()
    // this.getLocationById()
  },
  components: {
    PrintViewBar,
  },
  methods: {
    getSettings() {
      const storeId = this.$route.params.storeId
      // if (this.storeId === 0) {
      //   this.$router.push({ name: "location-dashboard" });
      // }
      return reportService.getSettings(storeId)
        .then((response) => {
          // commit('resetService')
          console.log('getSettings', response)
          this.currentBusiness = response.data[0]
        })
    },
    getLocationById() {
      const storeId = this.$route.params.storeId
      // if (this.storeId === 0) {
      //   this.$router.push({ name: "location-dashboard" });
      // }
      return locationService.getbyId(storeId)
        .then((response) => {
          // commit('resetService')
          console.log('location', response)
          this.currentBusiness = response.data[0]
          // response.ProductRelations.map(x => {
          //   if (x.serviceID === 192) commit('setPos', x)
          //   if (x.serviceID === 193) commit('setReconcile', x)
          //   if (x.serviceID === 194) commit('setCommercial', x)
          // })
          // commit('setLocation', response)
        })
      // this.setLocation(this.storeId);
      // return true
    },
    loadData() {
      const storeId = this.$route.params.storeId
      const invoiceId = this.$route.params.invoiceId

      this.Invoice = null
      console.log('load data got call', storeId, invoiceId)

      return reportService.Invoice
        .getById(storeId, { invoiceId: invoiceId })
        .then((response) => {
          console.log("response", response);
          this.Invoice = response.data[0];
          this.InvoiceDetails = response.data;
          this.isLoading = false;
        });
    },
    getPaymentByInvoiceId() {
      const storeId = this.$route.params.storeId
      const invoiceId = this.$route.params.invoiceId

      this.Invoice = null
      console.log('load data got call', storeId, invoiceId)

      return reportService.Invoice
        .getPaymentByInvoiceId(storeId, { invoiceId: invoiceId })
        .then((response) => {
          console.log("getPaymentByInvoiceId", response);
          // this.Invoice = response.data[0];
          this.Payments = response.data;
          this.Payments.map(row => {
            this.totalPayment += parseFloat(row.Amount)
          })
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }

  .no-print {
    display: none;
  }

  .detailBox {
    overflow: visible;
    height: 100%;
  }

  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}

.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}

.center {
  background-color: white;
  margin: auto;
  width: 100%;
}

/* @media print {
  .detailBox * {
    overflow: visible;
    height: 100%;
    page-break-before: always;
  }
}
.detailBox {
  overflow: auto;
  height: 600px;
} */
</style>
